import {
  PASSWORD_CHANGE_URL,
  PASSWORD_RESET_CONFIRM_URL,
  PASSWORD_RESET_URL,
  TOKEN_URL,
} from '@/api/auth';
import { CREATE_USER_URL } from '@/api/users';
import router from '@/router';
import { getLoginWithRedirect } from '@/router/getLoginWithRedirect';
import { useAuthStore } from '@/stores/auth';
import { SERVER_ERROR_MESSAGE, showToast } from '@/utils/displayError';
import { showErrorToUser } from '@/utils/request/showErrorToUser';

export const onResponseRejected = async (error: any) => {
  const authFlowUrls = [
    TOKEN_URL,
    CREATE_USER_URL,
    PASSWORD_RESET_URL,
    PASSWORD_RESET_CONFIRM_URL,
    PASSWORD_CHANGE_URL,
  ];

  const statusCode = error.response?.status;
  const authStore = useAuthStore();

  if (statusCode === 401 && error.config.url !== TOKEN_URL) {
    authStore.setIsAuthorized(false);
    const current = router.currentRoute.value;
    return router.push(
      current.meta.requiresAuth
        ? getLoginWithRedirect(current)
        : { name: 'login' },
    );
  }

  // If user tries to login with existing account that has no organization (django admin account for example)
  if (
    statusCode === 403 &&
    !error.config.url.includes('totp') &&
    error.response?.data?.code !== 'totp_required' &&
    !(
      error.config.url.includes('api/v1/controllers/') &&
      error.config.method === 'delete'
    ) &&
    !(
      error.config.url.match(/api\/v1\/organizations\/[^/]+\/$/) &&
      error.config.method === 'delete'
    )
  ) {
    router.push({ name: 'security' });
  }

  // Pass 4XX errors to toast
  if (
    `${error.response?.status}`[0] === '4' &&
    !error.config.url.includes('totp') &&
    !error.config.url.includes('change') &&
    !(statusCode === 429 && error.config.url.includes('/tcp-tunnels/')) &&
    !['totp_expired', 'totp_required'].includes(error.response.data.code)
  ) {
    showErrorToUser(error);
  }

  const url = error.config?.url ?? '';
  const isServerError = !error.response || `${statusCode}`[0] === '5';
  if (isServerError && authFlowUrls.some((flowUrl) => url.includes(flowUrl))) {
    showToast(SERVER_ERROR_MESSAGE);
  }

  return Promise.reject(error);
};
